<template>
  <navbar></navbar>
  <div class="w-full h-full">
    <router-view/>
  </div>
  <Footer v-if="!$router.currentRoute.value.meta.hideFooter"></Footer>
  <scroll-to-top/>
</template>

<script>
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import AOS from 'aos'
import ScrollToTop from './components/ScrollToTop'

// Блоки с data-aos стартуют с opacity: 0 и показываются, когда AOS решит, что
// они попали в кадр. Решение он принимает по позициям, посчитанным один раз при
// init, поэтому его нужно пересчитывать: после загрузки картинок (они сдвигают
// вёрстку) и после каждого перехода между страницами (это SPA, элементы новые).
const REVEAL_FALLBACK_MS = 2500

export default {
  components: { Navbar, Footer, ScrollToTop },

  mounted() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    AOS.init({
      once: true,
      duration: reducedMotion ? 0 : 600,
      offset: 40,
      disable: reducedMotion,
    })

    // картинки грузятся после первой отрисовки и меняют высоту страницы
    window.addEventListener('load', this.refreshAnimations)

    this.revealTimer = setTimeout(this.revealStuckBlocks, REVEAL_FALLBACK_MS)
  },

  unmounted() {
    window.removeEventListener('load', this.refreshAnimations)
    clearTimeout(this.revealTimer)
  },

  watch: {
    $route() {
      this.$nextTick(this.refreshAnimations)
      clearTimeout(this.revealTimer)
      this.revealTimer = setTimeout(this.revealStuckBlocks, REVEAL_FALLBACK_MS)
    },
  },

  methods: {
    refreshAnimations() {
      AOS.refreshHard()
    },

    // Страховка: пустая страница хуже страницы без анимации. Если блок к этому
    // моменту так и не показался, открываем его принудительно.
    revealStuckBlocks() {
      document
        .querySelectorAll('[data-aos]:not(.aos-animate)')
        .forEach((el) => el.classList.add('aos-animate'))
    },
  },
}

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

* {
  font-family: 'Montserrat', sans-serif;;
}
</style>
